import { JSONSchema7 } from 'json-schema';
import * as yup from 'yup';
import ControlState from '../../Shared/controlState';
import JSONSchema7Properties from '../../Shared/jSONSchema7Properties';

export default (
  control: ControlState
): {
  [key: string]: yup.AnySchema;
} => {
  const properties = control.schema?.properties as JSONSchema7Properties;
  const labelSchema = properties['label'] as JSONSchema7;
  const requiredSchema = properties['required'] as JSONSchema7;

  let controlYupSchema = yup
    .number()
    .transform((_, val) => (val ? Number(val) : null))
    .typeError('Must be a number')
    .nullable(true);

  if (!control.visible) {
    return {
      [control.id]: controlYupSchema
    };
  }

  if (requiredSchema && requiredSchema.default) {
    controlYupSchema = controlYupSchema.required(
      `${labelSchema.default} is required`
    );
  }

  return {
    [control.id]: controlYupSchema
  };
};
